import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RelatedContentRepresentation } from '@alfresco/js-api';
import { ProcessContentService } from '@alfresco/adf-process-services';

@Injectable({
  providedIn: 'root',
})
export class WkProcessContentService {
  constructor(private readonly processContentService: ProcessContentService) {}

  createTemporaryRawRelatedContent(
    file: any
  ): Observable<RelatedContentRepresentation> {
    return this.processContentService.createTemporaryRawRelatedContent(file);
  }

  getTaskRelatedContent(taskId: string, opts = null): Observable<any> {
    return this.processContentService.getTaskRelatedContent(taskId, opts);
  }

  getProcessRelatedContent(processId: string, opts = null) {
    return this.processContentService.getProcessRelatedContent(processId, opts);
  }
}
